<app-listado-listado-categorias
  [categorias]="categorias"
  tooltipCrear="Crear categoría"
  tituloCrear="Crear categoría de servicio técnico"
></app-listado-listado-categorias>
